export default "__VITE_ASSET__CRDz7_K7__"